(function () {
  var SECTION_ID = 'dc-search-overlay-results';
  var CATALOG_SECTION_ID = 'dc-search-catalog-scan';
  var SUGGEST_LIMIT = 50;
  var OVERLAY_LIMIT = 50;
  var SHORT_QUERY_OVERLAY_LIMIT = 250;
  var DEBOUNCE_MS = 200;
  var SHORT_QUERY_MAX_LEN = 2;
  var CATALOG_JSON_PAGE_SIZE = 250;
  var CATALOG_JSON_MAX_PAGES = 40;
  var activeSearchSeq = 0;

  function getConfig() {
    return window.dcSearchConfig || {};
  }

  function normalize(text) {
    return (text || '').toLowerCase();
  }

  /**
   * Product match: name, SKU, product type, or collection title (category).
   * Short queries (1–2 chars) use title + SKU only to avoid noisy category hits.
   */
  function productMatchesQuery(product, query) {
    var q = normalize(query).trim();
    if (!q) return false;

    if (normalize(product.title).indexOf(q) !== -1) return true;

    var skus = product.skus || [];
    for (var i = 0; i < skus.length; i++) {
      var sku = (skus[i] || '').trim();
      if (!sku) continue;
      if (normalize(sku).indexOf(q) !== -1) return true;
    }

    if (q.length <= SHORT_QUERY_MAX_LEN) return false;

    if (normalize(product.product_type).indexOf(q) !== -1) return true;

    var collections = product.collections || [];
    for (var c = 0; c < collections.length; c++) {
      if (normalize(collections[c]).indexOf(q) !== -1) return true;
    }

    return false;
  }

  function collectionMatchesQuery(collection, query) {
    var q = normalize(query).trim();
    if (!q) return false;
    return normalize(collection.title).indexOf(q) !== -1;
  }

  function splitPipeList(value) {
    if (!value || !value.trim()) return [];
    return value
      .split('|')
      .map(function (part) {
        return part.trim();
      })
      .filter(Boolean);
  }

  function mapJsonProduct(raw) {
    var skus = [];
    if (raw.variants && raw.variants.length) {
      raw.variants.forEach(function (v) {
        if (v.sku) skus.push(v.sku);
      });
    }

    return {
      url: '/products/' + raw.handle,
      title: raw.title || '',
      image: raw.images && raw.images[0] ? raw.images[0].src : '',
      product_type: raw.product_type || '',
      skus: skus,
      collections: [],
      subtitle: raw.product_type || '',
    };
  }

  function parseOverlayProductsFromHtml(html) {
    if (!html) return { products: [], currentPage: 1, totalPages: 1 };

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root =
      doc.querySelector('#dc-search-catalog-scan-results') ||
      doc.querySelector('#dc-search-overlay-section-results');
    var currentPage = 1;
    var totalPages = 1;

    if (root) {
      currentPage = parseInt(root.getAttribute('data-page') || '1', 10);
      totalPages = parseInt(root.getAttribute('data-pages') || '1', 10);
    }

    var nodes = doc.querySelectorAll('.dc-search-overlay-product');
    var products = [];

    nodes.forEach(function (node) {
      products.push({
        url: node.getAttribute('href'),
        title: node.getAttribute('data-title') || '',
        image: node.getAttribute('data-image') || '',
        product_type: node.getAttribute('data-product-type') || '',
        skus: splitPipeList(node.getAttribute('data-skus')),
        collections: splitPipeList(node.getAttribute('data-collections')),
        subtitle: node.getAttribute('data-product-type') || '',
      });
    });

    return { products: products, currentPage: currentPage, totalPages: totalPages };
  }

  function buildFullSearchUrl(query) {
    var cfg = getConfig();
    var base = cfg.searchUrl || '/search';
    return base + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=none';
  }

  function buildSuggestUrl(query) {
    var parts = [
      'q=' + encodeURIComponent(query),
      'resources[type]=product',
      'resources[type]=collection',
      'resources[limit]=' + SUGGEST_LIMIT,
      'resources[options][fields]=title,variants.sku,product_type',
      'resources[options][prefix]=none',
      'resources[options][unavailable_products]=hide',
    ];
    return '/search/suggest.json?' + parts.join('&');
  }

  function buildSectionFetchUrl(query) {
    var cfg = getConfig();
    var base = cfg.searchUrl || '/search';
    return (
      base +
      '?q=' +
      encodeURIComponent(query) +
      '&type=product&options%5Bprefix%5D=none&sections=' +
      SECTION_ID
    );
  }

  function buildCatalogScanUrl(query, page) {
    var cfg = getConfig();
    var base = cfg.catalogCollectionUrl || '/collections/all';
    return (
      base +
      '?sections=' +
      CATALOG_SECTION_ID +
      '&dc_q=' +
      encodeURIComponent(query) +
      '&page=' +
      page
    );
  }

  function getCatalogHandles() {
    var cfg = getConfig();
    if (cfg.catalogCollectionHandles && cfg.catalogCollectionHandles.length) {
      return cfg.catalogCollectionHandles;
    }
    return ['all'];
  }

  function isStaleSearch(seq, query) {
    if (seq !== activeSearchSeq) return true;
    var input = document.getElementById('custom-search-input-field');
    if (!input) return false;
    return input.value.trim() !== query;
  }

  function createProductLink(product) {
    var cfg = getConfig();
    var item = document.createElement('a');
    item.href = product.url;
    item.className = 'search-product-item';

    var img = document.createElement('img');
    img.src = product.image || cfg.noImageUrl || '';
    img.alt = product.title || '';

    var wrap = document.createElement('div');
    var titleEl = document.createElement('div');
    titleEl.className = 'search-product-title';
    titleEl.textContent = product.title || '';

    wrap.appendChild(titleEl);
    if (product.subtitle) {
      var sub = document.createElement('div');
      sub.className = 'search-product-subtitle';
      sub.textContent = product.subtitle;
      wrap.appendChild(sub);
    }

    item.appendChild(img);
    item.appendChild(wrap);
    return item;
  }

  function createCategoryLink(href, label) {
    var item = document.createElement('a');
    item.href = href;
    item.className = 'search-suggestion-item search-suggestion-item--category';
    item.textContent = label;
    return item;
  }

  function overlayLimitForQuery(query) {
    return query.length <= SHORT_QUERY_MAX_LEN ? SHORT_QUERY_OVERLAY_LIMIT : OVERLAY_LIMIT;
  }

  function mergeProducts(primary, secondary, query, limit) {
    var seen = Object.create(null);
    var merged = [];
    var max = limit || overlayLimitForQuery(query);

    function add(p) {
      if (!p || !p.url || seen[p.url]) return;
      if (!productMatchesQuery(p, query)) return;
      if (merged.length >= max) return;
      seen[p.url] = true;
      merged.push(p);
    }

    primary.forEach(add);
    secondary.forEach(add);
    return merged;
  }

  function mapSuggestProducts(raw, query) {
    return (raw || [])
      .map(function (p) {
        var skus = [];
        if (p.variants && p.variants.length) {
          p.variants.forEach(function (v) {
            if (v.sku) skus.push(v.sku);
          });
        }

        return {
          url: p.url,
          title: p.title,
          image: p.image,
          product_type: p.product_type || '',
          skus: skus,
          collections: [],
          subtitle: p.product_type || '',
        };
      })
      .filter(function (p) {
        return productMatchesQuery(p, query);
      });
  }

  /**
   * Categories column: matching collections + matching product types (deduped).
   * Kept separate from the products list.
   */
  function buildCategoryResults(collections, products, query) {
    var q = normalize(query).trim();
    var seen = Object.create(null);
    var categories = [];

    (collections || []).forEach(function (col) {
      if (!collectionMatchesQuery(col, query)) return;
      var key = normalize(col.title);
      if (!key || seen[key]) return;
      seen[key] = true;
      categories.push({
        url: col.url,
        title: col.title,
      });
    });

    if (q.length > SHORT_QUERY_MAX_LEN) {
      (products || []).forEach(function (product) {
        var type = (product.product_type || '').trim();
        if (!type) return;
        if (normalize(type).indexOf(q) === -1) return;
        var key = normalize(type);
        if (seen[key]) return;
        seen[key] = true;
        categories.push({
          url: buildFullSearchUrl(type),
          title: type,
        });
      });
    }

    return categories;
  }

  function paintSearchResults(query, products, categories, elements) {
    var fullUrl = buildFullSearchUrl(query);

    if (elements.suggestionsList) {
      elements.suggestionsList.innerHTML = '';
      if (categories.length > 0) {
        categories.forEach(function (cat) {
          elements.suggestionsList.appendChild(createCategoryLink(cat.url, cat.title));
        });
      } else {
        var emptyCat = document.createElement('div');
        emptyCat.style.fontSize = '12px';
        emptyCat.style.color = '#888';
        emptyCat.textContent = 'No categories found';
        elements.suggestionsList.appendChild(emptyCat);
      }
    }

    if (elements.productsList) {
      elements.productsList.innerHTML = '';
      if (products.length > 0) {
        products.forEach(function (product) {
          elements.productsList.appendChild(createProductLink(product));
        });
      } else {
        var empty = document.createElement('div');
        empty.style.fontSize = '12px';
        empty.style.color = '#888';
        empty.textContent = 'No products found';
        elements.productsList.appendChild(empty);
      }
    }

    if (elements.termText) elements.termText.textContent = query;
    if (elements.viewAllLink) elements.viewAllLink.href = fullUrl;
    if (elements.resultsBox) elements.resultsBox.style.display = 'block';
  }

  function fetchSectionProducts(query) {
    return fetch(buildSectionFetchUrl(query))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var parsed = parseOverlayProductsFromHtml(data && data[SECTION_ID]);
        return parsed.products;
      })
      .then(function (products) {
        return products.filter(function (p) {
          return productMatchesQuery(p, query);
        });
      })
      .catch(function () {
        return [];
      });
  }

  function fetchCatalogJsonPage(handle, page) {
    return fetch(
      '/collections/' + encodeURIComponent(handle) + '/products.json?limit=' + CATALOG_JSON_PAGE_SIZE + '&page=' + page
    )
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchCatalogProductsJson(query) {
    var handles = getCatalogHandles();
    var combined = [];
    var seen = Object.create(null);
    var max = overlayLimitForQuery(query);

    function addProducts(list) {
      list.forEach(function (raw) {
        if (combined.length >= max) return;
        var mapped = mapJsonProduct(raw);
        if (!productMatchesQuery(mapped, query)) return;
        if (seen[mapped.url]) return;
        seen[mapped.url] = true;
        combined.push(mapped);
      });
    }

    function scanHandle(handleIndex, page) {
      if (combined.length >= max) {
        return Promise.resolve(combined);
      }
      if (handleIndex >= handles.length) {
        return Promise.resolve(combined);
      }
      if (page > CATALOG_JSON_MAX_PAGES) {
        return scanHandle(handleIndex + 1, 1);
      }

      return fetchCatalogJsonPage(handles[handleIndex], page).then(function (data) {
        if (!data || !data.products || !data.products.length) {
          return scanHandle(handleIndex + 1, 1);
        }

        addProducts(data.products);

        if (data.products.length < CATALOG_JSON_PAGE_SIZE) {
          return scanHandle(handleIndex + 1, 1);
        }

        return scanHandle(handleIndex, page + 1);
      });
    }

    return scanHandle(0, 1);
  }

  function fetchCatalogScanPage(query, page) {
    return fetch(buildCatalogScanUrl(query, page))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return parseOverlayProductsFromHtml(data && data[CATALOG_SECTION_ID]);
      })
      .catch(function () {
        return { products: [], currentPage: page, totalPages: page };
      });
  }

  function fetchCatalogProductsSection(query) {
    var page = 1;
    var combined = [];
    var totalPages = 1;
    var max = overlayLimitForQuery(query);

    function nextPage() {
      if (page > totalPages || page > CATALOG_JSON_MAX_PAGES || combined.length >= max) {
        return Promise.resolve(combined.slice(0, max));
      }

      return fetchCatalogScanPage(query, page).then(function (result) {
        totalPages = result.totalPages || totalPages;

        result.products.forEach(function (p) {
          if (combined.length >= max) return;
          if (!productMatchesQuery(p, query)) return;
          var exists = combined.some(function (item) {
            return item.url === p.url;
          });
          if (!exists) combined.push(p);
        });

        page += 1;
        return nextPage();
      });
    }

    return nextPage();
  }

  function fetchCatalogProducts(query) {
    return fetchCatalogProductsJson(query).then(function (jsonProducts) {
      if (jsonProducts.length > 0) {
        return jsonProducts;
      }
      return fetchCatalogProductsSection(query);
    });
  }

  function shouldUseCatalogScan(query) {
    return query.length > 0 && query.length <= SHORT_QUERY_MAX_LEN;
  }

  window.openCustomSearch = function (e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    var overlay = document.getElementById('custom-top-search-bar');
    var inputField = document.getElementById('custom-search-input-field');

    if (overlay) {
      overlay.style.setProperty('display', 'block', 'important');
      overlay.style.setProperty('visibility', 'visible', 'important');
      overlay.style.setProperty('opacity', '1', 'important');
      document.body.classList.add('search-overlay-active');

      if (inputField) {
        setTimeout(function () {
          inputField.focus();
        }, 100);
      }
    }
  };

  window.closeCustomSearch = function () {
    var overlay = document.getElementById('custom-top-search-bar');
    var resultsBox = document.getElementById('custom-search-results-box');
    var inputField = document.getElementById('custom-search-input-field');
    var clearBtn = document.getElementById('custom-search-clear-btn');

    if (overlay) overlay.style.setProperty('display', 'none', 'important');
    document.body.classList.remove('search-overlay-active');
    if (resultsBox) resultsBox.style.display = 'none';
    if (inputField) inputField.value = '';
    if (clearBtn) clearBtn.style.display = 'none';
  };

  function runSearch(query, elements, seq) {
    var suggestPromise = fetch(buildSuggestUrl(query)).then(function (response) {
      return response.json();
    });

    var sectionPromise = fetchSectionProducts(query);
    var catalogPromise = shouldUseCatalogScan(query)
      ? fetchCatalogProducts(query)
      : Promise.resolve([]);

    return Promise.all([suggestPromise, sectionPromise, catalogPromise]).then(function (results) {
      if (isStaleSearch(seq, query)) return;

      var data = results[0];
      var sectionProducts = results[1];
      var catalogProducts = results[2];

      if (!data || !data.resources || !data.resources.results) {
        data = { resources: { results: {} } };
      }

      var res = data.resources.results;
      var suggestProducts = mapSuggestProducts(res.products || [], query);
      var maxResults = overlayLimitForQuery(query);
      var products = mergeProducts(suggestProducts, sectionProducts, query, maxResults);
      products = mergeProducts(products, catalogProducts, query, maxResults);

      var collections = res.collections || [];

      function finish(finalProducts) {
        if (isStaleSearch(seq, query)) return;
        var categories = buildCategoryResults(collections, finalProducts, query);
        paintSearchResults(query, finalProducts, categories, elements);
      }

      if (products.length > 0) {
        finish(products);
        return;
      }

      return fetchCatalogProducts(query).then(function (fallbackProducts) {
        if (isStaleSearch(seq, query)) return;
        var merged = mergeProducts(products, fallbackProducts, query, maxResults);
        finish(merged);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('custom-top-search-bar');
    var clearBtn = document.getElementById('custom-search-clear-btn');
    var inputField = document.getElementById('custom-search-input-field');
    var resultsBox = document.getElementById('custom-search-results-box');
    var suggestionsList = document.getElementById('custom-search-suggestions-list');
    var productsList = document.getElementById('custom-search-products-list');
    var viewAllLink = document.getElementById('custom-search-view-all-link');
    var termText = document.getElementById('custom-search-term-text');
    var debounceTimer;

    var elements = {
      suggestionsList: suggestionsList,
      productsList: productsList,
      viewAllLink: viewAllLink,
      termText: termText,
      resultsBox: resultsBox,
    };

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) {
          window.closeCustomSearch();
        }
      });
    }

    if (clearBtn && inputField) {
      clearBtn.addEventListener('click', function () {
        inputField.value = '';
        clearBtn.style.display = 'none';
        if (resultsBox) resultsBox.style.display = 'none';
        inputField.focus();
      });
    }

    if (!inputField) return;

    inputField.addEventListener('input', function () {
      var query = inputField.value.trim();

      if (query.length > 0) {
        if (clearBtn) clearBtn.style.display = 'block';
      } else {
        if (clearBtn) clearBtn.style.display = 'none';
        if (resultsBox) resultsBox.style.display = 'none';
        return;
      }

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var liveQuery = inputField.value.trim();
        if (!liveQuery) return;
        var seq = ++activeSearchSeq;
        runSearch(liveQuery, elements, seq).catch(function (err) {
          console.error(err);
        });
      }, DEBOUNCE_MS);
    });
  });
})();
